module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAiCAYAAAC5gzL5AAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADHSURBVHgB7ZPREcIgDECDxwBsoG7gCB3BDXQDzw3sCE5gN1AnUDdwBDewG6ShX7RNyuXgq8e7SzkgfSUUDMyAiBU1B4pqJu1shZcdNTeKPcRxVpi4R74+YAXTVRw1AlZCnEAJJ9mBksGeUCmbSH5D8RmNvWEsQZmLIGbLkXjkkPylCUvLfAV9BzIN5XLjtUFhRsFWUw7H1xjzS5b4R6rkmUPSr8Sf2DoY9H9HujtXijbot34/JlmRE7sW5MnlFEmRFMkiJFnoAHW8ZarvHW1iAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website/header/facebook.png
// module id = 287
// module chunks = 0 1 2